// extracted by mini-css-extract-plugin
export default {"root":"Verification_root__erE+e"};